import { redirectForAuthorization } from "../../auth/authProvider";
import configData from "./../../config.json";

export const downloadImage = async (id: string) : Promise<string> => {
  try {
    const token = localStorage.getItem("jwttoken");

    if (!token) {
      // Если токена нет, перенаправить на авторизацию
      await redirectForAuthorization();
      return '';
    }

    const response = await fetch(`${configData.ServerUrl}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Получение значения заголовка Content-Disposition
      const contentDisposition = response.headers.get("content-disposition");

      let filename = "";

      if (contentDisposition) {
        // Ищем filename*=
        let match = contentDisposition.match(
          /filename\*=['"]?UTF-8''([^'";]+)/i
        );
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        } else {
          // Ищем filename=
          match = contentDisposition.match(/filename=['"]?([^'";]+)/i);
          if (match && match[1]) {
            filename = match[1];
          }
        }
      }
      return url;
    } else {
      console.error("Error fetching image:", response.statusText);
      if (response.status === 401) {
        // Токен истек или недействителен, перенаправить на авторизацию
        await redirectForAuthorization();
      } else {
        // Обработка других ошибок (например, 403, 404 и т.д.)
        console.error(`Error: ${response.statusText} (${response.status})`);
      }
    }
  } catch (error: any) {
    console.error("Error during image fetch or authentication check:", error);
    // Перенаправляем на авторизацию только если это ошибка, связанная с аутентификацией
    if (error.name === "AuthenticationError") {
      await redirectForAuthorization();
    } else {
      // Обработка других ошибок
      console.error("Unexpected error:", error);
    }
  }
  return '';
};
